export default __webpack_public_path__ + "static/media/j-arc-logo-blue.754208af.svg";